import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-preview-images',
  templateUrl: './preview-images.component.html',
  styleUrls: ['./preview-images.component.scss']
})
export class PreviewImagesComponent implements OnInit {

  previewTitle: string;
  previewImages: any[];

  constructor(public dialogRef: MatDialogRef<PreviewImagesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data) {
      this.previewTitle = data.documentTitle;
      this.previewImages = data.images.filter(i=>i?i.location:false);

    }
   }

  ngOnInit() {
  }


  close() {
    this.dialogRef.close();
  }

  download(url: string, name: string){
    FileSaver.saveAs(url, name);
  }

    downloadZip(){
    var zip = new JSZip();
    const self = this;
    for (let i = 0; i < self.previewImages.length; i++) {
      JSZipUtils.getBinaryContent(this.previewImages[i].location, function (err, data) {
        if(err) {
           throw err; // or handle the error
        }
        zip.file("image-" + i, data, {binary:true});
     });
    }
    zip.generateAsync({ type: "blob" })
      .then(function (content) {
        FileSaver.saveAs(content, self.previewTitle + ".zip");
      });
  }
}
